
import { supabase } from '@/lib/supabase';
import { handleError, ErrorSeverity, ErrorContext } from '@/utils/errorHandler';

/**
 * Base service class with common utilities for data fetching
 */
export class BaseService {
  /**
   * Protected method to handle API errors consistently
   */
  protected static handleApiError(
    error: unknown, 
    message: string, 
    context?: Partial<ErrorContext>,
    severity: ErrorSeverity = ErrorSeverity.ERROR
  ): never {
    handleError(error, message, severity, context);
    throw error;
  }

  /**
   * Get the current user's organization ID from auth state
   */
  protected static async getCurrentOrgId(): Promise<string | null> {
    const { data } = await supabase.auth.getSession();
    return data.session?.user?.user_metadata?.organization_id || null;
  }
}
